import { render, staticRenderFns } from "./rworganisasi.vue?vue&type=template&id=6de8c48a"
import script from "./rworganisasi.vue?vue&type=script&lang=js"
export * from "./rworganisasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports